const theme = {
  colors: {
    background: {
      primary: "#fffbff",
      secondary: "#ffffff",
      lightGrey: "#efece9",
      grey: "#dad3cd",
    },

    text: {
      primary: "#1e1e1e",
      secondary: "#7c7165",
      light: "#fffbff",
    },
    border: {
      primary: "#dad3cd",
      secondary: "#7c7165",
    },

    accent: {
      yellow: "#ffdc00",
      orange: "#ff8a10",
      blue: "#3d7efd;",
      deepBlue: "#004f98",
      green: "#00aa3a",
    },
  },

  fonts: {
    regular: '"Montserrat-Regular", sans-serif',
    medium: '"Montserrat-Medium", sans-serif',
    semibold: '"Montserrat-Semibold", sans-serif',
    bold: '"Montserrat-Bold", sans-serif',
    extrabold: '"Montserrat-Extrabold", sans-serif',
  },
};

export default theme;
